import axios, { AxiosResponse } from 'axios';
import ApiURLs from '@/ApiURLs';
import { getIsHomeProvider } from "@/helpers/user";

class ChildcareService {
    saveP1StripeConnectedAccountLink(data: any) {
        return axios.post(ApiURLs.saveP1StripeConnectedAccountLink, data);
    }

    updateP1StripeConnectedAccountLink(data: any) {
        return axios.post(ApiURLs.updateP1StripeConnectedAccountLink, data);
    }

    saveHouseholdInfo(data: any) {
        return axios.post(ApiURLs.saveHouseholdInfo, data);
    }

    updateHouseholdInfo(data: any) {
        return axios.post(ApiURLs.updateHouseholdInfo, data);
    }

    saveProgramStatement(data: any) {
        return axios.post(ApiURLs.saveProgramStatement, data);
    }

    getBadges(BadgesNames: any) {
        return axios.get(ApiURLs.getBadges, {
            params: {
                BadgesNames
            }
        });
    }

    saveBadges(data: any) {
        return axios.post(ApiURLs.saveBadges, data);
    }

    updateBadges(data: any) {
        return axios.post(ApiURLs.updateBadges, data);
    }

    saveFamilyAmenities(data: any) {
        return axios.post(ApiURLs.saveFamilyAmenities, data);
    }

    saveHomeSafety(data: any) {
        return axios.post(ApiURLs.saveHomeSafety, data);
    }

    saveChildcareLocation(data: any) {
        return axios.post(ApiURLs.saveChildcareLocation, data);
    }

    saveParentBookingMethod(withApprovalRequest: boolean) {
        return axios.post(ApiURLs.saveParentBookingMethod, null, {
            params: {
                withApprovalRequest
            }
        })
    }

    saveAvailabilitySettings(data: any) {
        return axios.post(ApiURLs.saveAvailabilitySettings, data);
    }

    getAvailabilitySettings() {
        return axios.get(ApiURLs.getAvailabilitySettings);
    }

    getAcceptedAgeGroups() {
        return axios.get(ApiURLs.getAcceptedAgeGroups);
    }

    updateAvailabilitySettings(data: any) {
        return axios.post(ApiURLs.updateAvailabilitySettings, data);
    }

    saveAcceptedAgeGroups(data: any) {
        return axios.post(ApiURLs.saveAcceptedAgeGroups, data);
    }

    updateAcceptedAgeGroups(data: any) {
        return axios.post(ApiURLs.updateAcceptedAgeGroups, data);
    }

    saveHoursOfBusiness(data: any) {
        return axios.post(ApiURLs.saveHoursOfBusiness, data);
    }

    updateHoursOfBusiness(data: any) {
        return axios.post(ApiURLs.updateHoursOfBusiness, data);
    }

    getHoursOfBusiness() {
        return axios.get(ApiURLs.getHoursOfBusiness);
    }

    getPrices() {
        return axios.get(ApiURLs.getPrices);
    }

    savePrices(data: any) {
        return axios.post(ApiURLs.savePrices, data);
    }

    updatePrices(data: any) {
        return axios.post(ApiURLs.updatePrices, data);
    }

    setAvailableSpaces(data: any) {
        return axios.post(ApiURLs.setAvailableSpaces, data);
    }

    getAvailableSpaces() {
        return axios.get(ApiURLs.getAvailableSpaces);
    }

    saveCancellationOptions(data: any) {
        return axios.post(ApiURLs.saveCancellationOptions, data);
    }

    updateCancellationOptions(data: any) {
        return axios.post(ApiURLs.updateCancellationOptions, data);
    }

    getCancellationOptions() {
        return axios.get(ApiURLs.getCancellationOptions);
    }

    savePoliciesAndProcedures(data: any) {
        return axios.post(ApiURLs.savePoliciesAndProcedures, data);
    }

    updatePoliciesAndProcedures(data: any) {
        return axios.post(ApiURLs.updatePoliciesAndProcedures, data);
    }

    updatePoliciesAndProceduresFiles(data: any) {
        return axios.post(ApiURLs.updatePoliciesAndProceduresFiles, data, {
                                                                            headers: {
                                                                                'Content-Type': 'multipart/form-data'
                                                                            }
                                                                        }
        );
    }

    getPolicies() {
        return axios.get(ApiURLs.getPolicies);
    }

    getNotifications() {
        return axios.get(ApiURLs.getNotifications);
    }

    saveNotifications(data: any) {
        return axios.post(ApiURLs.saveNotifications, data);
    }

    updateNotifications(data: any) {
        return axios.post(ApiURLs.updateNotifications, data);
    }

    getProgramStatement() {
        return axios.get(ApiURLs.getProgramStatement);
    }

    updateProgramStatement(data: any) {
        return axios.post(ApiURLs.updateProgramStatement, data);
    }

    getHouseholdInfo() {
        return axios.get(ApiURLs.getHouseholdInfo);
    }

    getFamilyAmenities() {
        return axios.get(ApiURLs.getFamilyAmenities);
    }

    updateFamilyAmenities(data: any) {
        return axios.post(ApiURLs.updateFamilyAmenities, data);
    }

    updateHomeSafety(data: any) {
        return axios.post(ApiURLs.updateHomeSafety, data);
    }

    getHomeSafety() {
        return axios.get(ApiURLs.getHomeSafety);
    }

    getChildcareLocation() {
        return axios.get(ApiURLs.getChildcareLocation)
    }
    
    getChildcareLocationById(providerId: any) {
        return axios.get(ApiURLs.getChildcareLocationById, {
            params: {
                providerId
            }
        });
    }

    updateChildcareLocation(data: any) {
        return axios.post(ApiURLs.updateChildcareLocation, data)
    }

    getParentBookingMethod() {
        return axios.get(ApiURLs.getParentBookingMethod);
    }

    updateParentBookingMethod(withApprovalRequest: boolean) {
        return axios.post(ApiURLs.updateParentBookingMethod, null, {
            params: {
                withApprovalRequest
            }
        });
    }

    getChildcareEnrollmentSteps() {
        return axios.get(ApiURLs.getChildcareEnrollmentSteps);
    }

    getHistory() {
        return axios.get(ApiURLs.getHistory);
    }

    getProviderHistory() {
        return axios.get(ApiURLs.childcareGetHistory);
    }

    getProviderPolicies() {
        return axios.get(ApiURLs.getProviderPolicies);
    }

    getHolidays() {
        return axios.get(ApiURLs.getHolidays);
    }

    saveHolidays(data: any) {
        return axios.post(ApiURLs.saveHolidays, data);
    }

    getIsGeolocationShared() {
        return axios.get(ApiURLs.getIsGeolocationShared);
    }

    setIsGeolocationShared(data: any) {
        return axios.post(ApiURLs.setIsGeolocationShared, null, {
            params: data
        });
    }

    getProviderForCurrentUser() {
        let res;

        let isHomeProvider = getIsHomeProvider();
        if (isHomeProvider) {
            res = axios.get(ApiURLs.getProviderForCurrentUser);
        }
        else {
            res = new Promise<any>(resolve => resolve({ data: null }));
        }

        return(res);
    }
}

export default new ChildcareService();